<template>
  <v-app id="app">
		<v-idle :duration="900" @idle="onidle" v-show="false"/>
    <router-view />
  </v-app>
</template>
<script>
import { authService } from "@/services/authService.js";

export default {
	name: "login",
	methods: {
		onidle() {
			authService
        .logout(true)
    }
	}
}
</script>
<style>
@import "../node_modules/ag-grid-community/styles/ag-grid.css";
@import "../node_modules/ag-grid-community/styles/ag-theme-balham.css";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
